import React from 'react';

import { Layout } from 'components/Layout';
import { ReloanHero } from 'components/sections/ReloanHero';
import { releaseReviews } from 'content/reviews';
import { Reviews } from 'components/sections/Reviews';
import { howToCardsRelease } from 'content/howToCards';
import { HowToCards } from 'components/sections/HowToCards';
import { Magazine, MagazineArticleCard } from 'components/sections/Magazine';
import { Gutter } from 'components/Gutter';

interface Props {
  articles: MagazineArticleCard[];
}

export const Reloan: React.FC<Props> = ({ articles }) => (
  <Layout>
    <ReloanHero />
    <Gutter size="small">
      <HowToCards
        hideImages
        title={howToCardsRelease.title}
        howToItems={howToCardsRelease.howToItems}
        showBg
        showIcons
      />
    </Gutter>
    <Gutter size="medium">
      <Reviews title={releaseReviews.title} reviews={releaseReviews.reviews} />
    </Gutter>

    <Gutter size="medium">
      <Magazine articles={articles} />
    </Gutter>
  </Layout>
);
